<template>
<div class="w-100">
    <div class="worked-time-index-top-wrap flex justify-between align-items-center flex-wrap mb-2">
        <button @click="previousYear" class="btn btn-secondary flex align-items-center mb-2" :disabled="this.selected_year === this.company_create_year" onclick="this.blur()"><i class="fas fa-chevron-left"></i><span class="d-inline-block ml-1 hide-lte-991">Vorige jaar</span></button>
        <h4 class="card-title mb-2">{{ this.selected_year }}</h4>
        <button @click="nextYear" class="btn btn-secondary flex align-items-center mb-2" :disabled="this.current_year === this.selected_year" onclick="this.blur()"><span class="d-inline-block mr-1 hide-lte-991">Volgende jaar</span><i class="fas fa-chevron-right"></i></button>
    </div>
    <div class="position-relative overflow-hidden w-100">
        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="w-2/3">Medewerker</th>
                        <th style="line-height: 23px;">Overuren</th>
                        <th>
                            Tijd voor tijd
                            <div style="display: inline-block; white-space: normal;">
                                <div class="info-circle-wrap">
                                    <div class="info-circle">
                                        <span class="info-text">?</span>
                                    </div>
                                </div>
                                <div class="info-pop-up-wrap info-pop-up-wrap--hide">
                                    <div class="info-pop-up">
                                        <p class="mb-0">
                                            Compensatie van extra gewerkte uren krijg je terugbetaalt in tijd niet in gelden.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th style="line-height: 23px;">Beschikbare verlofuren</th>
                        <th style="line-height: 23px;">Opgenomen verlofuren</th>
                        <th>
                            Totaal opgebouwde verlofuren
                            <div style="display: inline-block; white-space: normal;">
                                <div class="info-circle-wrap">
                                    <div class="info-circle">
                                        <span class="info-text">?</span>
                                    </div>
                                </div>
                                <div class="info-pop-up-wrap info-pop-up-wrap--hide">
                                    <div class="info-pop-up">
                                        <p class="mb-0">
                                            Totaal aantal verlofuren zijn de uren minus het bovenwettelijk verlof en tijd voor tijd.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="employee in employees" v-bind:key="employee.id">
                        <td>{{ employee.name }}</td>
                        <td>{{ employee.overtime.toFixed(2) }}</td>
                        <td>{{ employee.time_for_time.availableLeave.toFixed(2) }}</td>
                        <td>{{ employee.profileLeaveInformation.availableLeave.toFixed(2) }}</td>
                        <td>{{ employee.profileLeaveInformation.totalLeaveTakenByYear.toFixed(2) }}</td>
                        <td>{{ employee.profileLeaveInformation.totalLeaveBuild.toFixed(2) }}</td>
                        <td v-if="employee.resend_mail_url != null">
                            <a class="btn btn-primary" v-bind:href="employee.resend_mail_url" data-toggle="tooltip" data-placement="left" title="Verstuur uitnodiging opnieuw">
                                <i class="fas fa-envelope"></i>
                            </a>
                            <a v-bind:href="employee.edit_url" class="btn btn-primary">
                                <i class="fas fa-eye"></i>
                            </a>
                        </td>
                        <td v-if="employee.resend_mail_url == null" class="text-right">
                            <a v-bind:href="employee.edit_url" class="btn btn-primary">
                                <i class="fas fa-eye"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: {
            company_create_year: {
                type: Number,
                required: true,
            },
        },
        data: function () {
            return {
                old_employees: [],
                employees: [],
                selected_year: 0,
                current_year: 0,
                company_create: 0,
            }
        },
        mounted: function () {
            this.selected_year = new Date().getFullYear();
            this.current_year = new Date().getFullYear();
            this.loadYear();
        },
        methods: {
            loadYear: function () {
                if (!this.old_employees.hasOwnProperty(this.selected_year.toString())){
                    this.employees = [];

                    let axios = require('axios');
                    axios.get(`/employer/profiles?year=${this.selected_year}`).then((response) => {
                        this.old_employees[this.selected_year.toString()] = response.data.employees;
                        this.employees = response.data.employees;
                    });
                } else {
                    this.employees = this.old_employees[this.selected_year.toString()];
                }
            },
            nextYear: function () {
                this.selected_year++;
                this.loadYear();
            },
            previousYear: function () {
                this.selected_year--;
                this.loadYear();
            }
        }
    }
</script>
